import { create } from "zustand"

import type { IPageResponse } from "@/types/IPageResponse"
import type { ICheckConversationResponse } from "@/types/messenger/ICheckConversationResponse"

type State = {
  unreadList: IPageResponse<ICheckConversationResponse> | null
}

type Actions = {
  setUnreadList: (newInstances: IPageResponse<ICheckConversationResponse>) => void
  resetUnreadList: () => void
}

const initialState: State = {
  unreadList: null
}

export const useUnreadStore = create<State & Actions>(set => ({
  unreadList: null,
  setUnreadList: (newUnreadList: IPageResponse<ICheckConversationResponse>) =>
    set(() => ({ unreadList: { ...newUnreadList } })),
  resetUnreadList: () => set(initialState)
}))
